module.exports = __webpack_public_path__ + "static/media/downOutlined.46777b54.svg";